import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface ReasonsBoxProps {
  reasons: string[];
}

const ReasonsBox = ({ reasons }: ReasonsBoxProps) => {
 if (!reasons || reasons.length === 0) return null;

  return (
    <>
   
      <Box mt={2} px={2}>
      <Typography fontWeight={600} mb={1}>
        Reason(s) for document upload:
      </Typography>
      {reasons.map((reason, reasonIndex) =>
        reason.split("|").map((r, i) => (
          <Typography
            key={`${reasonIndex}-${i}`}
            fontSize={13}
            color="error.main"
            sx={{ ml: 2, mb: 0.5 }}
          >
            • {r.trim()}
          </Typography>
        ))
      )}
    </Box>
    </>
  );
};

export default ReasonsBox;
